// extracted by mini-css-extract-plugin
export default {"reveal":"Reveal_reveal__SPBeB","visible":"Reveal_visible__+dmZC"};